<template>
  <div :class="className" @click="$emit('tab-change', thisTab)">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    currentTab: {
      required: true,
    },
    thisTab: {
      required: true,
    },
  },
  computed: {
    className() {
      return {
        "tab-btn": true,
        "tab-btn--active": this.thisTab === this.currentTab,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-btn {
  text-align: center;
  white-space: nowrap;
  padding: 14px 50px;
  border: 1px solid #cbcdd1;
  cursor: pointer;

  @media (max-width: 380px) {
    padding: 10px 14px;
    flex-grow: 1;
  }

  @media (max-width: 359px) {
    padding: 10px 12px;
    font-size: 14px;
  }

  &--active {
    background: #f2f6ff;
    border-color: #4971d0;
    outline: 1px solid #4971d0;
    z-index: 2;
  }
}
</style>
